var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sitebg"},[_c('div',{staticClass:"siteDiv"},[_c('div',{staticClass:"siteHeader"},[_c('div',[_c('div',{staticClass:"siteInfoDiv"},[_c('h5',[_vm._v(_vm._s(_vm.siteName))]),_c('p',[_vm._v("编号："+_vm._s(_vm.siteNo))]),_c('p',[_vm._v("所属部门："+_vm._s(_vm.siteDepart))]),_c('p',[_vm._v("站长姓名："+_vm._s(_vm.masterName))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }